import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, LanguageSelector } from "@tellescope/ui";
import { Card } from "@tellescope/design-system";
import { useOrganization } from "../../shared/store/organizationStore";
import { useIsRegistrationDisabled } from "../../shared/store/portalSchemaStore";

/**
 * Landing page for unauthenticated endusers.
 * Shows welcome message with options to sign in or create an account.
 */
export const LandingPage: React.FC = () => {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();
  const organization = useOrganization();
  const isRegistrationDisabled = useIsRegistrationDisabled();

  const handleSignIn = () => {
    navigate("/login");
  };

  const handleCreateAccount = () => {
    navigate("/register");
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <Card variant="floating" padding="root" className="w-full max-w-md">
        <Card.Header className="text-center">
          {organization?.logoURL && (
            <div className="flex justify-center mb-4">
              <img
                src={organization.logoURL}
                alt={organization.name || "Organization logo"}
                className="h-16 max-w-[200px] object-contain"
              />
            </div>
          )}
          <Card.Title className="text-2xl font-bold">{t("Welcome to the Patient Portal")}</Card.Title>
          <Card.Description>{t("Sign in to access your health information")}</Card.Description>
        </Card.Header>

        <Card.Body className="space-y-4">
          <Button onClick={handleSignIn} className="w-full" size="lg">
            {t("Sign In")}
          </Button>
          {!isRegistrationDisabled && (
            <Button onClick={handleCreateAccount} variant="outline" className="w-full" size="lg">
              {t("Create Account")}
            </Button>
          )}
        </Card.Body>

        <Card.Footer className="flex justify-center">
          <LanguageSelector />
        </Card.Footer>
      </Card>
    </div>
  );
};
